import { useEffect, useState } from 'react';
import { Anchor, Center, Container, Group, Image, Loader, Text, Title } from '@mantine/core';

import { APP_STORE_IMG, APP_STORE_LINK, GOOGLE_PLAY_IMG, GOOGLE_PLAY_LINK, LOGO_DARK } from 'constants/app';
import errorClasses from '../error/error.module.css';

type DeviceType = 'ios' | 'android' | 'desktop' | null;

const DownloadPage = () => {
  const [device, setDevice] = useState<DeviceType>(null);

  useEffect(() => {
    const ua = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(ua)) {
      setDevice('ios');
      window.location.replace(APP_STORE_LINK);
    } else if (/Android/.test(ua)) {
      setDevice('android');
      window.location.replace(`${GOOGLE_PLAY_LINK}&hl=en`);
    } else {
      setDevice('desktop');
    }
  }, []);

  if (device === null || device === 'ios' || device === 'android') {
    return (
      <Center h={'100vh'}>
        <Loader size={'lg'} />
      </Center>
    );
  }

  return (
    <Center h={'100vh'}>
      <Container>
        <Image
          src={LOGO_DARK}
          alt={'Webkredit.ch logo'}
          mx={'auto'}
          pb={'lg'}
          className={errorClasses.logo}
        />
        <Title className={errorClasses.title} pb={'sm'}>
          Webkredit.ch App herunterladen
        </Title>
        <Text size={'lg'} ta={'center'} className={errorClasses.description}>
          Wählen Sie Ihre Plattform und laden Sie die App herunter.
        </Text>
        <Group justify={'center'} gap={'xl'} mt={'xl'}>
          <Anchor href={APP_STORE_LINK} target={'_blank'}>
            <Image src={APP_STORE_IMG} alt={'App Store'} h={50} />
          </Anchor>
          <Anchor href={`${GOOGLE_PLAY_LINK}&hl=en`} target={'_blank'}>
            <Image src={GOOGLE_PLAY_IMG} alt={'Google Play'} h={50} />
          </Anchor>
        </Group>
      </Container>
    </Center>
  );
};

export default DownloadPage;
